module.exports = __webpack_public_path__ + "media/images/brand/150/MARQUESBRANDINGCO LOGO SOCIALMEDIA_DESTAQUES-98c2a81da42efc1293603de495d3bf20.png";